import React, { useEffect, useState } from "react"
import { Modal, Table } from "antd"
import styles from "./index.module.css"
import { DownloadOutlined } from "@ant-design/icons"

export const DownloadDocumentModal = ({ recordData, open, onCancel }) => {
  const [fileList, setFileList] = useState([])
  const columns = [
    {
      title: "Waiver Name",
      dataIndex: "name",
      key: "name",
      render: (text) => text || "document.pdf"
    },
    {
      title: "Signed on",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text) => text || "N/A"
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <DownloadOutlined
          className={styles.downloadIcon}
          onClick={async () => {
            try {
              const response = await fetch(record.url)
              if (!response.ok) throw new Error('Network response was not ok')
              const blob = await response.blob()
              const url = window.URL.createObjectURL(blob)
              const link = document.createElement('a')
              link.href = url
              link.download = record.name || `document-${record.index + 1}.pdf`
              document.body.appendChild(link)
              link.click()
              setTimeout(() => {
                document.body.removeChild(link)
                window.URL.revokeObjectURL(url)
              }, 100)
            } catch (error) {
              console.error('Download failed:', error)
              window.open(record.url, '_blank')
            }
          }}
        />
      )
    }
  ]
  useEffect(() => {
    const waivers = recordData?.signed_documents || []
    if (waivers.length > 0) {
      const fileObjects = waivers.map((waiverItem, index) => {
        const url = waiverItem?.url || waiverItem
        const fileName = url?.split("/").pop()?.split("%22")[0] || "document.pdf"
        return {
          uid: `existing-${Date.now()}-${index}`,
          name: fileName,
          url,
          createdAt: waiverItem?.created_at || "N/A",
          index,
          key: index
        }
      })
      setFileList(fileObjects)
    }
  }, [recordData?.signed_documents])

  return (
    <Modal open={open} onCancel={onCancel} footer={null} centered width={600} maskClosable={false}>
      <>
        {/* Documents Table */}
        <Table columns={columns} dataSource={fileList} pagination={false} size="small" loading={fileList.length === 0} rowKey="key" />
      </>
    </Modal>
  )
}
